export const API_URI = "https://api.beluxeproperties.com/"
